import React from "react";
import ReactDOM from "react-dom/client";
// 1. IMPORTA O NOVO CSS
import "./Admin.css";
import App from "./App";
// 2. Remove o 'index.css' que não usamos mais

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
